import React from 'react';
import Tooltip from '@hobs/components/Tooltip';
import PropTypes from 'prop-types';

import Styles from './Indicator.module.scss';

const Indicator = ({ message }) => {
  return (
    <div className={Styles['indicator-wrapper']}>
      <Tooltip tooltip={message} position="top">
        <div className={Styles.indicator}></div>
      </Tooltip>
    </div>
  );
};

Indicator.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
};

export default Indicator;
